import React, { useState, useEffect } from 'react';
import { loadNotes, saveNotes } from '../../utils/storage';
import styles from './Notes.module.css';

const Notes = ({ selectedDate, startDate, endDate }) => {
  const [noteText, setNoteText] = useState('');
  const [savedMessage, setSavedMessage] = useState('');

  const getNoteKey = () => {
    if (startDate && endDate) {
      return `range_${startDate.toDateString()}_to_${endDate.toDateString()}`;
    }
    if (selectedDate) {
      return `date_${selectedDate.toDateString()}`;
    }
    return 'general_month_note';
  };

  useEffect(() => {
    const notes = loadNotes();
    const key = getNoteKey();
    setNoteText(notes[key] || '');
  }, [selectedDate, startDate, endDate]);

  const handleSave = () => {
    const notes = loadNotes();
    const key = getNoteKey();
    notes[key] = noteText;
    saveNotes(notes);
    setSavedMessage('Saved!');
    setTimeout(() => setSavedMessage(''), 2000);
  };

  const getContextText = () => {
    if (startDate && endDate) {
      return `Notes for ${startDate.toDateString()} — ${endDate.toDateString()}`;
    }
    if (selectedDate) {
      return `Notes for ${selectedDate.toDateString()}`;
    }
    return 'General Monthly Notes';
  };

  return (
    <div className={styles.notesContainer}>
      <h3 className={styles.notesTitle}>📝 {getContextText()}</h3>
      <textarea
        className={styles.notesTextarea}
        value={noteText}
        onChange={(e) => setNoteText(e.target.value)}
        placeholder="Write your notes here... (automatically saved per date/range)"
        rows={6}
      />
      <button className={styles.saveButton} onClick={handleSave}>
        Save Note
      </button>
      {savedMessage && <span className={styles.savedMessage}>{savedMessage}</span>}
    </div>
  );
};

export default Notes;